import { render, staticRenderFns } from "./ScanQR.vue?vue&type=template&id=53d5da32"
import script from "./ScanQR.vue?vue&type=script&lang=js"
export * from "./ScanQR.vue?vue&type=script&lang=js"
import style0 from "./ScanQR.vue?vue&type=style&index=0&id=53d5da32&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports